// components/formbuilder/render/partials/RenderTabs.js
import React, { useEffect } from "react";
import FieldRenderRegistry from "../utils/FieldRenderRegistry";
import "./../assets/form-builder-render.css";
import { debug } from "../../../utils";
const RenderTabs = ({
  schema,
  formData,
  onChange,
  onCtrlBlur,
  meta,
  activeTab,
  setActiveTab,
  validationErrors,
  isReadOnly,
  fieldErrors,
  analysis }) => {
  const layout = meta.layout || "left";
  // ---- Extraction des onglets ----
  const tabs = Array.isArray(schema?.properties)
    ? [] // impossible mais safe
    : schema?.properties
      ? Object.entries(schema.properties).filter(
        ([, tab]) =>
          tab && typeof tab === "object" &&
          Object.keys(tab.properties || {}).length > 0
      )
      : [];
  // ---- Initialisation de l'onglet actif ----

  useEffect(() => {
    if (!tabs.length) return;
    // si activeTab n'existe plus → reset
    /*
    if (!tabs.some(([key]) => key === activeTab)) {

      // setActiveTab(tabs[0][0]);
    }
      */
  }, [schema]);
  if (tabs.length === 0) return <div>Aucun contenu à afficher.</div>;
  // ---- Rendu du contenu d’un onglet ----
  const renderTabContent = (tabKey, tabData) => {
    if (!tabKey || !tabData) return null;
    const tabSlug = tabData.slug || tabKey;
    return (
      <div key={tabKey} className="fb-slide-content">
        {tabs.length > 1 && tabData.title &&
          <div className="fb-tab-title">
            <h4><span>{tabData.title}</span></h4>
          </div>
        }
        {
          Object.entries(tabData.properties || {}).map(([fieldKey, field]) => {
            if (!field || field["x-hidden"]) return null;
            field.parents = [tabKey]
            const ui = field["x-ui"];
            const Comp = FieldRenderRegistry[ui];
            if (!Comp) return null;
            const fieldName = field.name || fieldKey;
            const fullPath = `${tabKey}.${fieldName}`;
            const fieldAnalysis =
              analysis?.[tabKey]?.[fieldName] || null;
            const value =
              formData?.[tabKey]?.[fieldName] !== undefined
                ? formData[tabKey][fieldName]
                : "";
            return (
              <Comp
                key={fieldKey}
                field={field}
                value={value}
                isReadOnly={isReadOnly}
                onChange={(v) => onChange(fullPath, v)}
                onBlur={onCtrlBlur}
                errorMessage=''
                errors={validationErrors?.[tabKey]?.[fieldName]}
                analysis={fieldAnalysis}
              />

            );
          })
        }
      </div >
    );
  };
  // ============================================================================
  //  MODE SLIDES (wizard)
  // ============================================================================
  if (layout === "slides") {



    const stepIndex = tabs.findIndex(([key]) => key === activeTab);
    if (stepIndex == -1) {

    }
    // sécurité : si activeTab n’existe pas encore → première étape
    const safeIndex = stepIndex === -1 ? 0 : stepIndex;
    const totalSteps = tabs.length;
    const progress = Math.round(((safeIndex + 1) / totalSteps) * 100);
    /*
    const goNext = () => {
      alert('goNext')
      if (safeIndex < totalSteps - 1) {
        setActiveTab(tabs[safeIndex + 1][0]);
      }
    };
    const goPrev = () => {
      alert('goPrev')
      if (safeIndex > 0) {
        setActiveTab(tabs[safeIndex - 1][0]);
      }
    };
    */
    const safePair = tabs[safeIndex] || [];
    const currentKey = safePair[0] || tabs[0][0];
    const currentTab = safePair[1] || tabs[0][1];
    return (
      <div className="fb-slides">
        {/* Contenu */}
        {renderTabContent(currentKey, currentTab)}
      </div>
    );
  }
  // ============================================================================
  //  MODES left / right / top
  // ============================================================================
  // Cas d'un seul onglet
  if (tabs.length === 1) {
    const pair = tabs[0];
    if (Array.isArray(pair)) {
      const [tabKey, tabData] = pair;
      return renderTabContent(tabKey, tabData);
    }
    return null;
  }
  return (
    <div className={`fb-tabs fb-tabs-${layout}`}>
      {/*
      <div className="fb-tabs-sidebar">
        {tabs.map((pair) => {
          if (!Array.isArray(pair)) return null;
          const [tabKey, tabData] = pair;
          if (!tabKey) return null;
          return (
            <button
              key={tabKey}
              type="button"
              className={`fb-tab-btn ${activeTab === tabKey ? "active" : ""}`}
              onClick={() => setActiveTab(tabKey)}
            >
              {tabData?.title || "Onglet"}
            </button>
          );
        })}
      </div>
      */}
      <div className="fb-tabs-content">
        {tabs.map((pair) => {
          if (!Array.isArray(pair)) return null;
          const [tabKey, tabData] = pair;
          if (activeTab === tabKey) {
            return renderTabContent(tabKey, tabData);
          }
          return null;
        })}
      </div>
    </div>
  );
};
export default RenderTabs;
